module.exports = __webpack_public_path__ + "static/media/similar-resources.352d25f2.svg";